import { render, staticRenderFns } from "./transferdetails.vue?vue&type=template&id=139f8f29&scoped=true"
import script from "./transferdetails.vue?vue&type=script&lang=js"
export * from "./transferdetails.vue?vue&type=script&lang=js"
import style0 from "./transferdetails.vue?vue&type=style&index=0&id=139f8f29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139f8f29",
  null
  
)

export default component.exports